import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    const { children, fallback } = this.props;
    if (error) {
      if (fallback) return fallback;
      const isDev = import.meta.env.DEV;
      const msg = isDev ? String(error?.message || "Unknown error") : "An unexpected error occurred. Please refresh.";
      return (
        <div
          style={{
            minHeight: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "32px",
            background: "var(--bg-base)",
            color: "var(--text-primary)",
            textAlign: "center",
            gap: "12px",
          }}
        >
          <span style={{ fontSize: "40px" }} aria-hidden>
            ⚠️
          </span>
          <h1 style={{ fontSize: "18px", fontWeight: 600, margin: 0 }}>Something went wrong</h1>
          <p className="text-secondary" style={{ fontSize: "14px", maxWidth: "420px", margin: 0 }}>
            {msg}
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "center", marginTop: "8px" }}>
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{
                padding: "10px 16px",
                borderRadius: "6px",
                border: "1px solid var(--border-bright)",
                background: "var(--bg-surface)",
                color: "var(--text-primary)",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Refresh page
            </button>
            <button
              type="button"
              onClick={() => {
                window.location.href = "/";
              }}
              style={{
                padding: "10px 16px",
                borderRadius: "6px",
                border: "none",
                background: "var(--accent)",
                color: "#0a0f1a",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Back to projects
            </button>
          </div>
        </div>
      );
    }
    return children;
  }
}
